var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-form"},[(_vm.active===1)?_c('FormList',{on:{"row":e=> _vm.row = e}}):_vm._e(),(_vm.active===2)?_c('FormCreate',{attrs:{"id":_vm.row.formId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }